import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLearning } from "../learning/learning-context";

export function AccountPage() {
  const { identity, resetLocalLearner } = useLearning();
  const [confirmReset, setConfirmReset] = useState(false);
  const navigate = useNavigate();

  const reset = async () => {
    await resetLocalLearner();
    setConfirmReset(false);
    navigate("/atlas");
  };

  return (
    <main className="simple-page">
      <header className="simple-hero">
        <p className="page-kicker">LOCAL PROFILE</p>
        <h1>Your learning stays with you.</h1>
        <p>This device remembers where you paused, so you can return to the same place in the Atlas.</p>
      </header>

      <section className="account-grid">
        <article className="account-card card">
          <span className="tag tag-sage">Saved here</span>
          <h2>This device</h2>
          <p>Your journey and safe stopping point are saved on this device.</p>
          <dl>
            <div><dt>Profile</dt><dd>{identity ? "Ready" : "Opening"}</dd></div>
            <div><dt>Cloud backup</dt><dd>Coming later</dd></div>
          </dl>
        </article>
        <article className="account-card card account-future">
          <span className="tag tag-accent">Coming later</span>
          <h2>Guardian account</h2>
          <p>A guardian will be able to make learner profiles and keep progress safe across devices.</p>
        </article>
      </section>

      <section className="reset-panel">
        <h2>Start this profile again</h2>
        <p>This clears the Atlas progress saved on this device.</p>
        {confirmReset ? (
          <div className="reset-actions" role="group" aria-label="Confirm local profile reset">
            <button className="btn btn-secondary" type="button" onClick={() => setConfirmReset(false)}>Keep progress</button>
            <button className="btn btn-primary" type="button" onClick={() => void reset()}>Clear progress</button>
          </div>
        ) : (
          <button className="btn btn-ghost" type="button" onClick={() => setConfirmReset(true)}>Reset this profile</button>
        )}
      </section>
    </main>
  );
}
